import styled from '@emotion/styled'

const CatalogGrid = styled.div`
  display: grid;
  align-content: flex-start;
  gap: 80px;
  padding: 20px 24px 72px;

  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    padding: 40px;
  }

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding: 80px 0;
  }
`

export default CatalogGrid

export const Group = styled.div`
  display: grid;
  gap: 24px;
`
